import { render, staticRenderFns } from "./window-primary.vue?vue&type=template&id=90c6f2fa&scoped=true&"
import script from "./window-primary.vue?vue&type=script&lang=js&"
export * from "./window-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c6f2fa",
  null
  
)

export default component.exports